import { ActionIcon, Button, Group, Table, Text } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import dayjs from 'dayjs'
import { useAddShortagesToExistingOrder } from 'hooks/shortage'
import { ShortageOrder, ShortageTableItem } from 'types/shortage'
import { getUnitName } from 'utils'

type Props = {
  shortages: Array<ShortageTableItem>
  shortageOrders: Array<ShortageOrder>
  onCancel: () => void
}

export default function AddToExistingOrder({ shortages, shortageOrders, onCancel }: Props) {
  const addShortagesToExistingOrder = useAddShortagesToExistingOrder()
  const unit = getUnitName(shortages[0].unit).short

  return (
    <>
      <Text mb="sm">Wybierz zamówienie, do którego chcesz dodać brakujące produkty</Text>
      <Table highlightOnHover>
        <Table.Thead>
          <Table.Tr>
            <Table.Th></Table.Th>
            <Table.Th>Data złożenia zamówienia</Table.Th>
            <Table.Th>Zapotrzebowanie</Table.Th>
            <Table.Th>Zamówiona ilość</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {shortageOrders.map((order) => (
            <Table.Tr key={order.id}>
              <Table.Td>
                <ActionIcon
                  onClick={() => {
                    addShortagesToExistingOrder.mutate({
                      shortageOrderId: order.id,
                      shortageIds: shortages.map((s) => s.id),
                    })
                  }}
                >
                  <IconPlus />
                </ActionIcon>
              </Table.Td>
              <Table.Td>{dayjs(order.createdAt).format('DD MMMM YYYY')}</Table.Td>
              <Table.Td>
                {order.shortageAmount} {unit}
              </Table.Td>
              <Table.Td>
                {order.orderedAmount} {unit}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
      <Group mt="md" justify="flex-end">
        <Button variant="default" onClick={onCancel}>
          Anuluj
        </Button>
      </Group>
    </>
  )
}
